import { getDocument, getRecommendationIdFromUrl } from "./getDocument";
import { getTitleName } from "./utils/getLegalDocument";
import { Logger } from "./utils/logger";
import { RecommendationTracker } from "./utils/recommendationTracking";
import { loadConsentAndTracking } from "./utils/loadConsentAndTracking";

import "./styles/main.css";
import "./styles/spinner.css";
import "./styles/responsive.css";

/**
 * 🔹 Lädt den Titel der Webseite aus Firestore und setzt ihn dynamisch.
 */
async function loadTitle() {
    try {
        const title = await getTitleName();
        Logger.debug("📦 Geladener Titel aus Firestore:", title);

        if (title && typeof title === "string" && title.trim() !== "") {
            document.title = title;
            Logger.info("✅ Titel gesetzt:", title);
        } else {
            document.title = "Mit bester Empfehlung";
            Logger.warn("⚠️ Kein gültiger Titel gefunden – Fallback verwendet.");
        }
    } catch (error) {
        Logger.error("❌ Fehler beim Laden des Titels", error);
    }
}

/**
 * 🔹 Wird aufgerufen, wenn der DOM vollständig geladen ist.
 */
async function onDomReady() {
    Logger.info("🚀 DOM vollständig geladen. Lade Inhalte...");

    try {
        const success = await getDocument();
        await loadTitle();

        const recommendationId = getRecommendationIdFromUrl();
        if (recommendationId && success) {
            await RecommendationTracker.trackRecommendation("linkClicked", recommendationId);
            Logger.info("📈 Empfehlung getrackt:", recommendationId);
        }

        // 🔄 Zentrale Consent- & Tracking-Verwaltung (CMP-Erkennung, Consent-Prüfung, Nachladen)
        await loadConsentAndTracking();

    } catch (error) {
        Logger.error("❌ Fehler während des Ladeprozesses", error);
    }
}

// ✅ Falls DOM bereits geladen ist, sofort ausführen, sonst auf `DOMContentLoaded` warten
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDomReady);
} else {
    onDomReady();
}
